import React, { Fragment, PureComponent } from 'react';
import { Link } from 'react-router-dom';
import DocumentTitle from 'react-document-title';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import skills from 'data/skills';

import HeaderCompact from 'components/HeaderCompact';
import Page from 'components/Page';
import PageBody from 'components/PageBody';
import Skill, { PDFDownload, SkillItem, SkillRating, SkillSort } from 'components/Skill';

class Skills extends PureComponent {
  state = {
    sort: 'title',
  };

  setSort = sort => {
    this.setState({ sort });
  };

  sortSkills = (a, b) => {
    if (this.state.sort === 'rating') {
      return b.rating - a.rating;
    } else {
      if (a.title.toLowerCase() < b.title.toLowerCase()) {
        return -1;
      }
      if (a.title.toLowerCase() > b.title.toLowerCase()) {
        return 1;
      }
      return 0;
    }
  };

  render() {
    return (
      <Page>
        <DocumentTitle title="Skills // Chris Tieman" />
        <HeaderCompact />
        <PageBody header="Skills // Deep-Dive">
          <Skill header="Projects">
            <SkillItem
              header={
                <a href="https://scummypoker.com/" target="_blank" rel="noreferrer noopener">
                  Scummy Poker <span role="img" aria-label="Scummy">🤙</span>
                </a>
              }
              details="Node // React // Redis // Socket.io"
            >
              Website created to allow people who use Scrum/Agile to do backlog estimation in a creative way. Allows
              people to set their own card images and chat while working together or remote.
            </SkillItem>
            <SkillItem
              header={
                <a href="https://daily-nook.web.app/" target="_blank" rel="noreferrer noopener">
                  Daily Nook <span role="img" aria-label="Butterfly">🦋</span>
                </a>
              }
              details="React // Redux // Firebase"
            >
              When Animal Crossing first came out, I was hooked along with most of my friends. Being the 
              completionist that I am, I had to make a tool for tracking active fish and bugs, as well 
              as keeping track of what I've already caught.
            </SkillItem>
            <SkillItem
              header={
                <a href="https://debt-rainbow.web.app/" target="_blank" rel="noreferrer noopener">
                  Debt Rainbow
                </a>
              }
              details="React // Redux // Firebase"
            >
              This little tool was something I made for myself to track my student loan paydown progress{' '}
              <span role="img" aria-label="Sad">
                😭
              </span>
              . I really liked where it was headed, so I decided to hook it up to Firebase and share it with other
              people looking to pay off debt.
            </SkillItem>
            <SkillItem header="Spotify Roadtrip" details="Angular // Node // Spotify API">
              Website for allowing users to load in one or multiple spotify playlists and then shuffles them in an
              organized fashion so that music is played in a by-user fashion for an evenly shuffled playlist.
            </SkillItem>
            <SkillItem
              header={
                <a href="https://play-midnight.web.app/" target="_blank" rel="noreferrer noopener">
                  Play Midnight
                </a>
              }
              details="Chrome Extension // JavaScript // SASS"
            >
              Extension for Google Chrome that injects JavaScript and CSS into the Google Music Player website in order
              to give users a way to customize a darker look for Google Play Music.
            </SkillItem>
            <SkillItem header="iHeartColors" details="Angular // Node // MongoDB">
              A full screen javascript-driven color picker that allows you to pick colors using mouse coordinates to
              save palettes to your account and a public gallery.
            </SkillItem>
            <SkillItem>
              <Link to="/work">
                <strong>View More Work</strong>
              </Link>
            </SkillItem>
          </Skill>
          <Skill header="Expertise" compact>
            <SkillSort sort={this.state.sort} setSort={sort => this.setSort(sort)} />
            <TransitionGroup component={Fragment}>
              {skills.sort(this.sortSkills).map(skill => (
                <CSSTransition key={skill.title} timeout={500} classNames="fade" appear>
                  <SkillRating header={skill.title} rating={skill.rating} icon={skill.icon} />
                </CSSTransition>
              ))}
            </TransitionGroup>
          </Skill>
          <Skill header="Experience">
            <SkillItem header="Moser Consulting" subheader="Consultant" details="08/2017 - Present">
              Writing applications for various clients using mixtures of React, Rails, and Node. Maintaining core
              internal applications that are used by coworkers.
            </SkillItem>
            <SkillItem header="Indiana Interactive" subheader="UI Developer" details="4/2015 - 08/2017">
              Create custom AngularJS applications for various government clients using different combinations of
              Foundation, Bootstrap, and custom Node development tools. In charge of final tweaks to looks/design of our
              applications.
            </SkillItem>
            <SkillItem header="Fat Atom" subheader="WordPress Developer" details="2/2012 - 4/2015">
              Developed themes, plugins, backends for WordPress using Twitter Bootstrap and other grid systems to create
              responsive, cross-browser websites or extensions.
            </SkillItem>
            <SkillItem
              header="Purdue University"
              subheader="Network Operations &amp; Security Officer"
              details="9/2009 - 12/2011"
            >
              Created a custom map to monitor the network status across campus using Adobe Flash and Actionscript, as
              well as using Request Tracker to respond to security threats.
            </SkillItem>
          </Skill>
          <Skill header="Education" compact>
            <SkillItem header="Indiana University - Purdue University Indianapolis" details="December 2014">
              <i className="small">Bachelor of Science in Computer Graphics Technology</i>
            </SkillItem>
          </Skill>
          <PDFDownload>
            <a href="/files/Chris_Tieman_Resume.pdf" target="_blank" rel="noreferrer noopener">
              View PDF Resume
            </a>
          </PDFDownload>
        </PageBody>
      </Page>
    );
  }
}

export default Skills;



// WEBPACK FOOTER //
// ./src/pages/Skills.js